<div class="row pb-2 row-height">
  <div class="col col-12 col-lg-12 p-0 d-flex justify-content-between align-items-center w-100">
    <h1>Help</h1>
    <div [innerHtml]="version" class="strong"></div>
  </div>
  <div class="contentbox">
    <div class="col-12" [innerHtml]="linkContent | keepHtml" id="help-section"></div>
  </div>
</div>
